<template  lang="pug">
  .marketing-audit
    el-row
      el-col(:span="4") {{ $t('审核结果') }}
      el-col(:span="20")
        span(v-if="isView") {{ $t(auditData.result === 1 ? '通过' : '拒绝' ) }}
        el-radio-group(
          v-else
          v-model="auditData.result"
        )
          el-radio(:label="1") {{ $t('通过 ') }}
          el-radio(:label="2") {{ $t('拒绝') }}

    el-row
      el-col(:span="4") {{ $t('备注') }}
      el-col(:span="20" style="position: relative")
        div(v-if="isView")
          display-text-container(:text="auditData.remark")
        template(v-else)
          el-input(
            v-model="auditData.remark"
            type="textarea"
            :rows="8"
            style="width: 380px"
            :placeholder="$t('备注不多于500字')"
            :class="{'has-error': errors.has('remark_field') }"
            v-validate="'max:500'"
            data-vv-as="remark_field"
            name="remark_field"
          )
          p(class="input-error") {{ errors.first('remark_field') }}
</template>

<script>
import DisplayTextContainer from '@/components/DisplayTextContainer'

export default {
  model: {
    prop: 'auditData'
  },
  components: {
    DisplayTextContainer
  },
  props: {
    auditData: {
      type: Object,
      default () {
        return {
          result: 1,
          remark: null
        }
      }
    }
  }
}
</script>
